import { layers } from '@atlassian/jira-common-styles/src';
import type { UserPickerSelectStylesConfig } from './types';

export const defaultUserPickerStyles: UserPickerSelectStylesConfig = {
	menuPortal: (base) => ({
		...base,
		zIndex: String(layers.modal),
	}),
};
